
interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  centered?: boolean;
  className?: string;
}

export const SectionHeader = ({ 
  title, 
  subtitle, 
  centered = false, 
  className = '' 
}: SectionHeaderProps) => {
  const alignment = centered ? 'text-center' : 'text-left';
  
  return (
    <div className={`${alignment} ${className}`}>
      <h2 className="text-[22px] font-semibold text-[#0e3851] mb-2">
        {title}
      </h2>
      {subtitle && (
        <p className="text-[15px] text-gray-600 max-w-2xl">
          {subtitle}
        </p>
      )}
    </div>
  );
};
